import { Component } from '@angular/core';

import {LoadingController, ModalController, NavParams, ViewController} from 'ionic-angular';

import { ConferenceData } from '../../../../providers/conference-data';
import { MissionsData } from '../../../../providers/missions-data';
import { UiData } from '../../../../providers/ui-data';
import {UserData} from "../../../../providers/user-data";

import { JobSelectForm } from '../../../utils/job-select/job-select';
import { Geolocation } from '@ionic-native/geolocation';
import {LocationSelectForm} from "../../../utils/location-select/location-select";

declare var google: any;

@Component({
    selector: 'page-missions-filter-form',
    templateUrl: 'missions-filter-form.html'
})
export class MissionsFilterFormPage {
    tracks: Array<{name: string, isChecked: boolean}> = [];
    searchFilters : any;
    test:any;
    lengthRange : any ;
    locationSelectModal: any;
    loading: any = false;
    sectors: any = false;
    choosen_sectors: any = false;
    inited: any = false;
    currently_loading: any = false;
    mode = 'location';

    constructor(

        public confData: ConferenceData,
        public navParams: NavParams,
        public viewCtrl: ViewController,
        public userData: UserData,
        public missionsData: MissionsData,
        public uiData: UiData,
        public modalCtrl: ModalController,
        private geolocation: Geolocation,
        public loadingCtrl: LoadingController
    ) {
        this.test= {'lower':5, 'upper':20};
        // passed in array of track names that should be excluded (unchecked)
        let excludedTrackNames = this.navParams.data;

        this.mode = this.navParams.data.mode;
        this.searchFilters = this.navParams.data.filters;
        this.searchFilters[this.mode].enabled = true;
        if(this.mode == "sector")
        {

            this.sectors = this.uiData.sectorsList();
            if(this.searchFilters[this.mode].sectors && Object.keys(this.searchFilters[this.mode].sectors).length>0)
            {
                this.choosen_sectors=this.searchFilters[this.mode].sectors;
            }
            else
            {
                this.choosen_sectors={};
                for(let i = 0;i<this.sectors.length;i++)
                {
                    this.choosen_sectors[this.sectors[i].slug]=true;
                }
            }
        }
        this.lengthRange = uiData.getLengthRanges();

    }
    ngAfterViewInit() {
        this.getUserInfos();
    }
    getUserInfos() {
        var that = this;

    }
    resetFilters() {
        // reset all of the toggles to be checked
        this.tracks.forEach(track => {
            track.isChecked = true;
        });
    }
    checkAllSectors(value) {
        for(let i=0;i<Object.keys(this.choosen_sectors).length;i++)
        {
            this.choosen_sectors[Object.keys(this.choosen_sectors)[i]]=value;
        }
    }
    applyFilters() {
        if(this.mode == 'sector')
        {
            /* if all are checked, we disable filter */
            var reset = true;
            var allFalse = true;
            for(let i=0;i<Object.keys(this.choosen_sectors).length;i++)
            {
                if(!this.choosen_sectors[Object.keys(this.choosen_sectors)[i]])reset=false;
                if(this.choosen_sectors[Object.keys(this.choosen_sectors)[i]])allFalse=false;
            }
            if(reset || allFalse)
            {
                this.searchFilters.sector.enabled=false;
            }
            this.searchFilters.sector.sectors = this.choosen_sectors;

        }
        this.dismiss(this.searchFilters);
    }
    setLoading(state,msg=""){
        if(msg == "")msg = 'Chargement des missions ...';
        if(state)
        {
            this.currently_loading = true;
            this.loading = this.loadingCtrl.create({
                content: msg
            });
            this.loading.present();
        }
        else if(this.loading){
            this.currently_loading = false;
            this.loading.dismiss();
        }
    }
    updateSearchFilters(category)
    {
        /*console.log(this.searchFilters[category]);
        console.log("Change filter for :"+category);
        this.missionsData.updateSearchFilters(category,this.searchFilters[category]);*/
        var that = this;
        if(category=="location-mode"){
            if(this.searchFilters.location.mode=="position")
            {
                that.setLoading(true,'Géolocalisation en cours ...');
                setTimeout(function(){
                    if(that.currently_loading) {
                        that.searchFilters.location.mode = 'address';
                        that.setLoading(false);
                        that.userData.geolocationError();
                    }
                },5000);
                this.geolocation.getCurrentPosition().then((resp) => {
                    this.searchFilters.location.lat = resp.coords.latitude;
                    this.searchFilters.location.lng = resp.coords.longitude;
                    this.searchFilters.location.enabled = true;
                    var geocoder = new google.maps.Geocoder;
                    var latlng = {lat: resp.coords.latitude, lng: resp.coords.longitude};
                    var that = this;
                    geocoder.geocode({'location': latlng}, function(results, status) {

                        if (status === 'OK') {
                            if (results[0]) {
                                that.searchFilters.location.address = results[0].formatted_address;
                                that.setLoading(false);
                            } else {
                                that.searchFilters.location.mode = 'address';
                                that.setLoading(false);
                                that.userData.geolocationError();
                            }
                        } else {
                            that.searchFilters.location.mode = 'address';
                            that.setLoading(false);
                            that.userData.geolocationError();
                        }
                    });
                }).catch((error) => {
                    that.searchFilters.location.mode = 'address';
                    that.setLoading(false);
                    that.userData.geolocationError();

                });
            }
            else
            {
                this.chooseLocation();
            }
        }
        if(category=="location"){
            this.searchFilters.location.enabled=true;
        }
        if(category=="job" && this.searchFilters.job.enabled && (!this.searchFilters.job.jobs || this.searchFilters.job.jobs.length==0))
        {
            this.addJobFilter();
        }
    }
    dismiss(data?: any) {
        // using the injected ViewController this page
        // can "dismiss" itself and pass back data
        if(!data)
        {
            if(this.mode == "job")this.searchFilters.job.enabled = false;
            if(this.mode == "sector")this.searchFilters.sector.enabled = false;
            data = this.searchFilters;
        }
        if(this.mode == "job" && (!data.job.jobs || data.job.jobs.length == 0)) {

            this.searchFilters.job.enabled = false;
            data = this.searchFilters;
        }
        this.viewCtrl.dismiss(data);
    }
    addJobFilter()
    {
        let jobSelectModal = this.modalCtrl.create(JobSelectForm, { mode: "certificates" });
        jobSelectModal.onDidDismiss(data => {
            if(data.success)
            {
                if(!this.searchFilters.job.jobs)this.searchFilters.job.jobs=[];
                let found = false;
                for(let y=0; y<this.searchFilters.job.jobs.length;y++){
                    if(this.searchFilters.job.jobs[y]==data.name)found=true;
                }
                if(!found)
                    this.searchFilters.job.jobs.push(data.name);
            }
            else
            {

            }
        });
        jobSelectModal.present();
    }
    removeJobFilter(job)
    {
        var jobs = [];
        if(this.searchFilters.job.jobs)
        for(let i = 0; i < this.searchFilters.job.jobs.length ; i++)
        {
            if(this.searchFilters.job.jobs[i] != job)
            {
                jobs.push(this.searchFilters.job.jobs[i])
            }
        }
        this.searchFilters.job.jobs = jobs;
        if(this.searchFilters.job.jobs.length==0)
        {
            this.searchFilters.job.enabled = false;
        }
    }
    chooseLocation()
    {
        var that = this;
        this.locationSelectModal = this.modalCtrl.create(LocationSelectForm, { mode: "address" });
        this.locationSelectModal.onDidDismiss(place => {
            let locationData = null;
            if (place.geometry !== undefined) {
                let geometry = place.geometry;
                locationData = {
                    lng: geometry.location.lng(),
                    lat: geometry.location.lat(),
                    mode: "address",
                    address:place.formatted_address,
                    enabled: true,
                    distance:50
                };
                this.searchFilters.location = locationData;
            }
            else if(place.mode !== undefined) {
                locationData = place.data
            }

            if(locationData)
                this.searchFilters.location = locationData;
        });
        this.locationSelectModal.present();
    }
    toggle(cat)
    {
        if(!this.searchFilters[cat].enabled)this.searchFilters[cat].enabled=true;
        else this.searchFilters[cat].enabled=false;
    }
    resetFilter()
    {
        //this.searchFilters[this.mode]
        this.searchFilters[this.mode].enabled = false;
        if(this.mode != 'job')
        {
            /* Reload default value from User Provider */
            this.searchFilters[this.mode] = Object.assign({},this.userData.defaultRegistriesValues.searchFilters[this.mode]);
        }
        this.dismiss(this.searchFilters);
    }
}



// WEBPACK FOOTER //
// ./src/pages/missions/missions-filter/missions-filter-form/missions-filter-form.ts